






















import Vue from 'vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import {
  $draggableImages,
  removeDraggableImage,
  replaceDraggableImage,
  $droppableImages,
} from '@/pages/common/parts/tasks/moving-images-on-image-input-answer/form/moving-images-on-image-answer-form.model'
import ImageMatchItem from './ImageMatchItem.vue'

export default Vue.extend({
  name: `CorrectImagesMatchPicker`,
  effector: {
    $draggableImages,
    $droppableImages,
  },
  components: {
    BaseButton,
    ImageMatchItem,
  },
  methods: {
    replaceDraggableImage,
    removeDraggableImage,
  },
})
